<template>
  <div class="sidebar-wrapper sidebar-theme fixed-top">
    <div id="dismiss" class="d-lg-none"><i class="flaticon-cancel-12"></i></div>
    <nav id="sidebar">
      <ul class="navbar-nav theme-brand flex-row  d-none d-lg-flex">
        <li class="nav-item d-flex">
          <router-link :to="{name: 'dashboard'}" class="p-2">
            <img :src="baseUrl + 'assets/images/logo.png'" class="img-fluid brand-logo" alt="logo"  />
          </router-link>
        </li>
      </ul>
      <ul class="list-unstyled menu-categories" id="accordionExample">
        <li class="menu">
          <router-link :to="{name: 'dashboard'}" data-toggle="collapse" aria-expanded="false" class="nav-item">
            <div>
              <i class="flaticon-computer-6 ml-3"></i>
              <span>Dashboard</span>
            </div>
          </router-link>
        </li>
        <li class="menu">
          <router-link :to="{name: 'users'}" data-toggle="collapse" aria-expanded="false" class="nav-item">
            <div>
              <i class="flaticon-user-6 ml-3"></i>
              <span>Users</span>
            </div>
          </router-link>
        </li>
        <li class="menu">
          <router-link :to="{name: 'agency'}" data-toggle="collapse" aria-expanded="false" class="nav-item">
            <div>
              <i class="flaticon-user-1 ml-3"></i>
              <span>Agency</span>
            </div>
          </router-link>
        </li>
        <li class="menu">
          <router-link :to="{name: 'version'}" data-toggle="collapse" aria-expanded="false" class="nav-item">
            <div>
              <i class="flaticon-view ml-3"></i>
              <span>Version</span>
            </div>
          </router-link>
        </li>
        <li class="menu">
          <router-link :to="{name: 'logs'}" data-toggle="collapse" aria-expanded="false" class="nav-item">
            <div>
              <i class="flaticon-log-1 ml-3"></i>
              <span>Log</span>
            </div>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({
      settings: 'settings/getSettings',
      account: 'auth/getAccount'
    })
  },
  mounted() {
    window.$(".nav-item").on("click", function() {
      //change attr of other..
      window.$(".dropdown-toggle").not(this).attr("aria-expanded", "false")
      //addclass of other..
      window.$(".dropdown-toggle").not(this).addClass("collapsed")
      //remove show class from others
      window.$(".list-unstyled").not(window.$(this).next("ul")).removeClass("show")
    })

  }
}
</script>